import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Circle.svg",
  "use": "Circle.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Circle.svg\"><path d=\"M32.01,56.0208a24,24,0,1,1,24-24A24,24,0,0,1,32.01,56.0208Zm0-44a20,20,0,1,0,20,20A20,20,0,0,0,32.01,12.0207Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol